export default __webpack_public_path__ + "static/media/GR8 7A-1D-7EC.ecc53f73.jpg";